export const gameRounds = {
  gameRounds: "Game Rounds",
  advanceFilter: "Advance Filter",
  userAlias: "User Alias",
  username: "Username",
  roundId: "ROUND ID",
  moduleCode: "MODULE CODE",
  betAmount: "BET AMOUNT",
  settleAmount: "SETTLE AMOUNT",
  depositAmont: "DEPOSIT AMOUNT",
  winLoss: "WIN/LOSS",
  openBalance: "OPEN BALANCE",
  closeBalance: "CLOSED BALANCE",
  status: "Status",
  date: "DATE",
  viewDetail: "VIEW DETAIL",
  searchGameId: "Search game id",
  phoneNumber: "Phone Number",
  gameName: "Game Name",
  from: "From",
  to: "To",
  cancel: "Cancel",
  cancelAmount: "Cancel Amount",
  filter: "Filter",
  actions: "ACTIONS",
  roundId: "ROUND ID",
  amount: "AMOUNT",
  openBalance: "OPEN BALANCE",
  closeBalance: "CLOSED BALANCE",
  source: "SOURCE",
  resettle: "resettle",
  viewGameResult: "View Game Result",
  gameResultDetails: "GAME Result Details",
  originalRoundId: "Original RoundId",
  refCode2: "RefCode2",
  winAmount: "Win Amount",
  close: "close",
  createdAt: "created At",
  updatedAt: "updated At",
  error: "Error",
  details: "Details",
  searchGameId: "Search game id...",
  withdrawAmount: "Withdraw Amount",
  viewUser: "View User",
  amount: "Amont",
  originalRoundBetId: "Original Round Bet Id",
  validBet: "Valid Bet",
};
